import { exclamationCircleIcon } from "../../elements/icons/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import dialog from "../dialog.js";
import ReportDisclaimer from "../../../models/ReportDisclaimer.js";

/**
 * Renders an information button. Once clicked, the button shows a disclaimer message for
 * an agency, a company, and a specific period.
 *
 * @param {Agency} [agency] - Agency to use for content computation
 * @param {Company} [company] - Company to use for content computation
 * @param {Period} [period] - Period to use for content computation
 * @param {Date} [date] - Date related to the content
 */
export default class DisclaimerIconWidget extends Widget {
	constructor({ agency, company, period, date }) {
		super(...arguments);
		this._company = company;

		this._templateVariables = ReportDisclaimer.buildTemplateVariables({
			agency,
			company,
			currentPeriod: period,
			date,
		});
	}

	renderContentOn(html) {
		html.a(
			{
				klass: "disclaimer-icon",
				click: this._showDisclaimer.bind(this),
			},
			exclamationCircleIcon,
		);
	}

	_showDisclaimer() {
		const disclaimer = this._company.getReportDisclaimer();

		dialog({
			header: disclaimer.expandHeader(this._templateVariables),
			body: (html) => {
				disclaimer
					.getContentAsParagraphs(this._templateVariables)
					.map((p) => html.p(p));
			},
		}).show();
	}
}
